function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo } from 'redux-ui-router';
import __ from 'ramda/src/__';
import i18n from 'invision-core/src/components/i18n/i18n';
import { DateRangeId, getRelativeShortListShortcuts, getShortListShortcuts } from 'invision-core/src/components/helpers/daterange.shortcut.helper';
import { getFilterService } from 'invision-core/src/components/injectables/injector.helper';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { NON_BULK_SERVICE_STATUSES } from 'invision-core/src/constants/status.constants';
import { fetchCodeTypesThunk, fetchNetworkEventSubTypes, fetchNetworkEventTypes, fetchUnitOfMeasureTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { MetadataCodeLoadedSelector, MetadataCodeTypeDictionarySelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import CustomerCareLocaleKeys from '../../../../locales/keys';
import { CurrentCustomerIdSelector, RouteParams } from '../../../../reducers/selectors/customer.selectors';
import { ConvergentBillerAccountUsageDetailsByServiceIdSelector, ConvergentBillerCurrencyCodeSelector, ConvergentBillerSubscriberSummaryServicesAvailableSelector, CurrentAccountCurrencyCodeSelector, IsFetchingAccountUsageDetailsSelector } from '../../../../reducers/selectors/customer.convergent.biller.selectors';
import { retrieveConvergentBillerAccountUsageDetails } from '../../../../reducers/actions/customer.convergent.biller.actions';
import { clearUsageDetailsRecoverableUIState, retrieveUsageDetailsGroupedEntitlements, retrieveUsageDetailsServiceEntitlements, retrieveUsageDetailsSharedEntitlements, searchUsageDetailsEntitlementName, setSelectedCallCategories, updateNetworkEventTypeFilter, updateNetworkSubEventTypeFilter, updateUsageDetailsCurrencyCode, updateUsageDetailsDateFilter, updateUsageDetailsPaginationData, updateUsageDetailsSearchEntitlementsDatePicker, updateUsageDetailsSearchEntitlementsIncludeExpired, updateUsageDetailsSelectedEntitlementDetails, updateUsageDetailsSort, updateUsageDetailsTotalAmount } from '../../../../reducers/actions/usage.details.actions';
import { ENTITLEMENT_ACTIVATION_STATUS, getColumnDefinitions, USAGE_SORT_DIRECTION, USAGE_SORT_FIELD, USAGES_LIMIT_WARNING_CODE } from './usage.details.table.constants';
import { AccountUsageDetailsEntitlementsSelector, AccountUsageDetailsTableDataSelector, FormattedServiceAttributeValueSelector, IsLoadingEntitlementsSelector, IsSharedEntintitlementUsageSelector, SelectedEntitlementDetailsSelector, SelectedEntitlementSelector, SelectedNetworkEventSubTypeFiltersSelector, SelectedNetworkEventTypeFiltersFormatSelector, SelectedNetworkEventTypeFiltersSelector, UsageDetailsPageTitleSelector, UsageDetailsPaginationDataSelector, UsageDetailsSearchEntitlementsDatePickerSelector, UsageDetailsSearchEntitlementsIncludeExpiredSelector, UsageDetailsSearchedEntitlementNameSelector, UsageDetailsSelectedCallCategoriesSelector, UsageDetailsSelectedEndDateSelector, UsageDetailsSelectedStartDateSelector, UsageDetailsSortParamsSelector, UsageDetailsTotalAmountSelector } from '../../../../reducers/selectors/usage.details.selectors';
import { SelectedServiceDetailsSelector } from '../../../../reducers/selectors/selected.service.details.selectors';
import { LOCATION_OVERRIDES_DISPLAY_MAX, USAGE_CAPS_URL } from '../usageCaps/usage.caps.constants';
import { SERVICE_USAGE_DETAILS_STATE_NAME } from './usage.details.config';
import { getSuspensionTypeByCode } from '../../../../reducers/selectors/services.list.selectors.helper';
var UsageDetailsController = /*#__PURE__*/function () {
  function UsageDetailsController($ngRedux, $scope, $timeout, uiGridConstants, uiNotificationService) {
    _classCallCheck(this, UsageDetailsController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $scope: $scope,
      $timeout: $timeout,
      callCategories: [],
      entitlementName: undefined,
      isUsageCapsButtonVisible: false,
      NON_BULK_SERVICE_STATUSES: NON_BULK_SERVICE_STATUSES,
      onCallCategoryChanged: this.onCallCategoryChanged.bind(this),
      onGridRegisterApi: this.onGridRegisterApi.bind(this),
      onPageSelected: this.onPageSelected.bind(this),
      onPageSizeOptionSelected: this.onPageSizeOptionSelected.bind(this),
      onSearchCleared: this.onSearchCleared.bind(this),
      searchEntitlementName: this.searchEntitlementName.bind(this),
      searchEntitlementsDatePicker: {
        shortcut: null,
        startDate: null,
        endDate: null
      },
      showAll: false,
      uiGridConstants: uiGridConstants,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(UsageDetailsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var codeTables = [CODES.CallCategory, CODES.RegularExpression, CODES.ServiceAttribute, CODES.UsageUnitConversion];
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          accountUsageTableData: AccountUsageDetailsTableDataSelector(store),
          callCategories: UsageDetailsSelectedCallCategoriesSelector(store),
          callCategoryCodeTableValues: MetadataCodeTypeDictionarySelector(CODES.CallCategory, store),
          currentAccountCurrencyCode: CurrentAccountCurrencyCodeSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          endDate: UsageDetailsSelectedEndDateSelector(store),
          entitlementCurrencyCode: ConvergentBillerCurrencyCodeSelector(store),
          entitlementName: UsageDetailsSearchedEntitlementNameSelector(store),
          entitlements: AccountUsageDetailsEntitlementsSelector(store),
          formattedServiceAttributeValue: FormattedServiceAttributeValueSelector(store),
          includeExpiredEntitlements: UsageDetailsSearchEntitlementsIncludeExpiredSelector(store),
          isCodeTableLoaded: MetadataCodeLoadedSelector(__, store),
          isLoadingEntitlements: IsLoadingEntitlementsSelector(store),
          isLoadingUsageDetails: IsFetchingAccountUsageDetailsSelector(store),
          isSharedEntitlementUsage: IsSharedEntintitlementUsageSelector(store),
          networkEventSubTypesLoaded: MetadataCodeLoadedSelector(CODES.NetworkEventSubType, store),
          networkEventTypesLoaded: MetadataCodeLoadedSelector(CODES.NetworkEventType, store),
          paginationData: UsageDetailsPaginationDataSelector(store),
          routeParams: RouteParams(store),
          searchEntitlementsDatePicker: UsageDetailsSearchEntitlementsDatePickerSelector(store),
          selectedEntitlement: SelectedEntitlementSelector(store),
          selectedEntitlementDetails: SelectedEntitlementDetailsSelector(store),
          selectedNetworkEventSubTypeFilters: SelectedNetworkEventSubTypeFiltersSelector(store),
          selectedNetworkEventTypeFiltersFormat: SelectedNetworkEventTypeFiltersFormatSelector(store),
          selectedNetworkEventTypes: SelectedNetworkEventTypeFiltersSelector(store),
          serviceDetails: SelectedServiceDetailsSelector(store),
          servicesAvailable: ConvergentBillerSubscriberSummaryServicesAvailableSelector(store),
          sortParams: UsageDetailsSortParamsSelector(store),
          startDate: UsageDetailsSelectedStartDateSelector(store),
          totalAmount: UsageDetailsTotalAmountSelector(store),
          unitsOfMeasureLoaded: MetadataCodeLoadedSelector(CODES.UnitsOfMeasure, store),
          usageDetails: ConvergentBillerAccountUsageDetailsByServiceIdSelector(store),
          usageDetailsPageTitle: UsageDetailsPageTitleSelector(store)
        };
      };
      var controllerActions = {
        clearUsageDetailsRecoverableUIState: clearUsageDetailsRecoverableUIState,
        fetchCodeTypesThunk: fetchCodeTypesThunk,
        fetchNetworkEventSubTypes: fetchNetworkEventSubTypes,
        fetchNetworkEventTypes: fetchNetworkEventTypes,
        fetchUnitOfMeasureTypes: fetchUnitOfMeasureTypes,
        retrieveConvergentBillerAccountUsageDetails: retrieveConvergentBillerAccountUsageDetails,
        retrieveUsageDetailsGroupedEntitlements: retrieveUsageDetailsGroupedEntitlements,
        retrieveUsageDetailsServiceEntitlements: retrieveUsageDetailsServiceEntitlements,
        retrieveUsageDetailsSharedEntitlements: retrieveUsageDetailsSharedEntitlements,
        searchUsageDetailsEntitlementName: searchUsageDetailsEntitlementName,
        setSelectedCallCategories: setSelectedCallCategories,
        stateGo: stateGo,
        updateNetworkEventTypeFilter: updateNetworkEventTypeFilter,
        updateNetworkSubEventTypeFilter: updateNetworkSubEventTypeFilter,
        updateUsageDetailsCurrencyCode: updateUsageDetailsCurrencyCode,
        updateUsageDetailsDateFilter: updateUsageDetailsDateFilter,
        updateUsageDetailsPaginationData: updateUsageDetailsPaginationData,
        updateUsageDetailsSearchEntitlementsDatePicker: updateUsageDetailsSearchEntitlementsDatePicker,
        updateUsageDetailsSearchEntitlementsIncludeExpired: updateUsageDetailsSearchEntitlementsIncludeExpired,
        updateUsageDetailsSelectedEntitlementDetails: updateUsageDetailsSelectedEntitlementDetails,
        updateUsageDetailsSort: updateUsageDetailsSort,
        updateUsageDetailsTotalAmount: updateUsageDetailsTotalAmount
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      codeTables.forEach(function (code) {
        if (!_this.state.isCodeTableLoaded(code)) {
          _this.actions.fetchCodeTypesThunk(code).catch(_this.onApiError);
        }
      });
      this.stateOrName = SERVICE_USAGE_DETAILS_STATE_NAME;
      this.optionalParams = {
        customerId: this.state.currentCustomerId
      };
      this.CustomerCareLocaleKeys = CustomerCareLocaleKeys;
      this.$filter = getFilterService();
      this.entitlementColumn = {
        field: 'entitlementName',
        displayName: i18n.translate(CustomerCareLocaleKeys.ENTITLEMENT),
        visible: this.isEntitlementColumnVisible()
      };
      this.tableColDefs = [this.entitlementColumn].concat(_toConsumableArray(getColumnDefinitions(this.uiGridConstants, this.$filter)));
      this.dateShortcuts = [getShortListShortcuts(), getRelativeShortListShortcuts()];
      this.showFilters = false;
      this.tooltipListTemplate = require('./fieldTemplates/tooltip.list.template.html');
      this.tableConfig = {
        columnDefs: this.tableColDefs,
        data: this.state.accountUsageTableData,
        onRegisterApi: this.onGridRegisterApi,
        useExternalSorting: true
      };
      if (!this.state.networkEventSubTypesLoaded) {
        this.actions.fetchNetworkEventSubTypes();
      }
      if (!this.state.networkEventTypesLoaded) {
        this.actions.fetchNetworkEventTypes();
      }
      if (!this.state.unitsOfMeasureLoaded) {
        this.actions.fetchUnitOfMeasureTypes();
      }
      this.updateSelectedService = function (service) {
        _this.actions.stateGo(SERVICE_USAGE_DETAILS_STATE_NAME, {
          serviceIdentifierValue: service.ServiceIdentifier.Value,
          serviceIdentifierName: service.ServiceIdentifier.ServiceIdentifierName
        });
      };
      this.onDateRangeChanged = function (startDate, endDate) {
        _this.selectedShortcut = _this.getDateRangeShortCutFromStartAndEndDates(startDate, endDate);
        _this.actions.updateUsageDetailsDateFilter({
          startDate: startDate,
          endDate: endDate
        });
        _this._resetPagination();
        _this._retrieveConvergentBillerAccountUsageDetails();
      };
      this.initializeSearchEntitlementsDatePicker = function () {
        if (_this.state.searchEntitlementsDatePicker.startDate && _this.state.searchEntitlementsDatePicker.endDate) {
          _this.searchEntitlementsDatePicker.shortcut = _this.getDateRangeShortCutFromStartAndEndDates(_this.state.searchEntitlementsDatePicker.startDate, _this.state.searchEntitlementsDatePicker.endDate);
        } else {
          _this.searchEntitlementsDatePicker.shortcut = getShortListShortcuts().find(function (sc) {
            return sc.id === DateRangeId.last30Days;
          });
        }
        if (_this.searchEntitlementsDatePicker.shortcut) {
          _this.searchEntitlementsDatePicker.startDate = _this.searchEntitlementsDatePicker.shortcut.start;
          _this.searchEntitlementsDatePicker.endDate = _this.searchEntitlementsDatePicker.shortcut.end;
        } else {
          _this.searchEntitlementsDatePicker.startDate = _this.state.searchEntitlementsDatePicker.startDate;
          _this.searchEntitlementsDatePicker.endDate = _this.state.searchEntitlementsDatePicker.endDate;
        }
        _this.actions.updateUsageDetailsSearchEntitlementsDatePicker(_this.searchEntitlementsDatePicker);
        if (_this.state.searchEntitlementsDatePicker.startDate && _this.state.searchEntitlementsDatePicker.endDate) {
          _this.syncUsageAndEntitlementFilters();
        }
      };
      this.onSearchEntitlementsDateRangeChange = function (startDate, endDate) {
        _this.searchEntitlementsDatePicker.startDate = startDate;
        _this.searchEntitlementsDatePicker.endDate = endDate;
        _this.actions.updateUsageDetailsSearchEntitlementsDatePicker(_this.searchEntitlementsDatePicker);
        if (_this.state.includeExpiredEntitlements && _this.searchEntitlementsDatePicker.startDate && _this.searchEntitlementsDatePicker.endDate) {
          _this.retrieveEntitlements(true);
        }
      };
      this.onIncludeRemovedChange = function () {
        _this.actions.updateUsageDetailsSearchEntitlementsIncludeExpired(!_this.state.includeExpiredEntitlements);
        if (!_this.state.includeExpiredEntitlements) {
          _this._setDateRangeToDefault();
          _this.setSearchEntitlementsDatePickerToDefaults();
        }
        if (_this.searchEntitlementsDatePicker.startDate && _this.searchEntitlementsDatePicker.endDate) {
          _this.retrieveEntitlements(true);
        }
      };
      this._initDateRangeAndRetreiveUsageDetails = function () {
        _this._setDateRangeToDefault();
        _this._resetPagination();
        _this._retrieveConvergentBillerAccountUsageDetails();
      };
      this.showFilters = true;
      this.retrieveEntitlements().then(function () {
        if (_this.state.searchEntitlementsDatePicker.startDate && _this.state.searchEntitlementsDatePicker.endDate) {
          _this.syncUsageAndEntitlementFilters();
          _this._resetPagination();
          _this._retrieveConvergentBillerAccountUsageDetails();
        } else {
          if (!_this.state.startDate || !_this.state.endDate) {
            _this._initDateRangeAndRetreiveUsageDetails();
          } else {
            _this.selectedShortcut = _this.getDateRangeShortCutFromStartAndEndDates(_this.state.startDate, _this.state.endDate);
            if (_this.selectedShortcut) {
              _this.onDateRangeChanged(_this.selectedShortcut.start, _this.selectedShortcut.end);
            } else {
              _this.onDateRangeChanged(_this.state.startDate, _this.state.endDate);
            }
          }
        }
        _this.initializeSearchEntitlementsDatePicker();
      });
      this.syncUsageAndEntitlementFilters = function () {
        _this.selectedShortcut = _this.getDateRangeShortCutFromStartAndEndDates(_this.state.searchEntitlementsDatePicker.startDate, _this.state.searchEntitlementsDatePicker.endDate);
        _this.actions.updateUsageDetailsDateFilter({
          startDate: _this.state.searchEntitlementsDatePicker.startDate,
          endDate: _this.state.searchEntitlementsDatePicker.endDate
        });
      };
      this.getDateRangeShortCutFromStartAndEndDates = function (startDate, endDate) {
        var matchingShortcut = null;
        if (_this.dateShortcuts[0] && _this.dateShortcuts[1]) {
          matchingShortcut = [].concat(_toConsumableArray(_this.dateShortcuts[0]), _toConsumableArray(_this.dateShortcuts[1])).find(function (shortcut) {
            var dateCheckStart = new Date(shortcut.start);
            var dateCheckEnd = new Date(shortcut.end);
            var ourDateStart = new Date(startDate);
            var ourDateEnd = new Date(endDate);
            dateCheckStart.setMinutes(0, 0);
            dateCheckEnd.setMinutes(0, 0);
            ourDateStart.setMinutes(0, 0);
            ourDateEnd.setMinutes(0, 0);
            dateCheckStart = dateCheckStart.toUTCString();
            dateCheckEnd = dateCheckEnd.toUTCString();
            ourDateStart = ourDateStart.toUTCString();
            ourDateEnd = ourDateEnd.toUTCString();
            return dateCheckStart === ourDateStart && dateCheckEnd === ourDateEnd;
          });
        }
        return matchingShortcut;
      };
      this.additionalUsageDetailsPopupConfig = {
        onRegisterApi: function onRegisterApi(evt) {
          _this.additionalUsageDetailsPopupConfig = evt.api;
        }
      };
    }
  }, {
    key: "onCallCategoryChanged",
    value: function onCallCategoryChanged(callCategories) {
      this.actions.setSelectedCallCategories((callCategories || []).map(function (callCategory) {
        return callCategory.id;
      }));
      this._resetPagination();
      this._retrieveConvergentBillerAccountUsageDetails();
    }
  }, {
    key: "searchEntitlementName",
    value: function searchEntitlementName(entitlementName) {
      this.actions.searchUsageDetailsEntitlementName(entitlementName);
      this._resetPagination();
      this._retrieveConvergentBillerAccountUsageDetails();
    }
  }, {
    key: "onSearchCleared",
    value: function onSearchCleared() {
      this.actions.searchUsageDetailsEntitlementName(null);
      this._resetPagination();
      this._retrieveConvergentBillerAccountUsageDetails();
    }
  }, {
    key: "isDataLoading",
    value: function isDataLoading() {
      return this.state.isLoadingUsageDetails || !this.state.unitsOfMeasureLoaded || this.state.isLoadingEntitlements;
    }
  }, {
    key: "retrieveEntitlements",
    value: function retrieveEntitlements() {
      var _this2 = this;
      var isFilterChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.state.isSharedEntitlementUsage && this.state.routeParams.groupCode) {
        return this.actions.retrieveUsageDetailsGroupedEntitlements(this.state.routeParams.groupCode, {
          ServiceAttributeId: this.state.routeParams.serviceAttributeId,
          Value: this.state.routeParams.serviceIdentifierValue
        }).catch(function (error) {
          _this2.uiNotificationService.transientError(error.translatedMessage);
        });
      } else if (this.state.isSharedEntitlementUsage) {
        return this.actions.retrieveUsageDetailsSharedEntitlements(this.state.currentCustomerId, this.state.routeParams.serviceIdentifierValue).catch(function (error) {
          _this2.uiNotificationService.transientError(error.translatedMessage);
        });
      } else {
        var searchByDateFilterAndIncludeAll = this.state.includeExpiredEntitlements && this.state.searchEntitlementsDatePicker.startDate && this.state.searchEntitlementsDatePicker.endDate;
        return this.actions.retrieveUsageDetailsServiceEntitlements(this.state.currentCustomerId, this.state.routeParams.serviceIdentifierValue, this.state.includeExpiredEntitlements || undefined, searchByDateFilterAndIncludeAll ? this.state.searchEntitlementsDatePicker.startDate : undefined, searchByDateFilterAndIncludeAll ? this.state.searchEntitlementsDatePicker.endDate : undefined).then(function (data) {
          if (isFilterChange) {
            _this2.resetEntitlementSelectionOnFilter(data === null || data === void 0 ? void 0 : data.ServiceEntitlementBalances);
            _this2.actions.setSelectedCallCategories([]);
            _this2.syncUsageAndEntitlementFilters();
            _this2._resetPagination();
            _this2._retrieveConvergentBillerAccountUsageDetails();
            _this2.callCategories = [];
          }
        }).catch(function (error) {
          _this2.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "resetEntitlementSelectionOnFilter",
    value: function resetEntitlementSelectionOnFilter(serviceEntitlementBalances) {
      if (serviceEntitlementBalances.length) {
        var entitlementToSelect = serviceEntitlementBalances[0];
        this.selectEntitlement(0, entitlementToSelect.EntitlementIdentifier.EntitlementId || entitlementToSelect.EntitlementIdentifier.GroupCode, entitlementToSelect.EntitlementIdentifier.BalanceIterationId);
      }
    }
  }, {
    key: "_retrieveConvergentBillerAccountUsageDetails",
    value: function _retrieveConvergentBillerAccountUsageDetails() {
      var _this3 = this;
      return this.actions.retrieveConvergentBillerAccountUsageDetails(this._buildRetreiveAccountUsageDetailsRequest()).then(function (response) {
        _this3.actions.updateUsageDetailsTotalAmount(response.TotalAmount);
        _this3.actions.updateUsageDetailsCurrencyCode(response.CurrencyCode);
        _this3.determineUsageCapsButtonVisibility();
        _this3.tableConfig.data = _this3.state.accountUsageTableData;
        _this3.usagesLimitExceededWarning = (response.Warnings || []).find(function (Obj) {
          return Obj.Code === USAGES_LIMIT_WARNING_CODE;
        }) ? i18n.translate(CustomerCareLocaleKeys.USAGE_DETAILS.USAGES_LIMIT_EXCEEDED_WARNING) : null;
      }).catch(function (error) {
        _this3.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "_setDateRangeToDefault",
    value: function _setDateRangeToDefault() {
      this.selectedShortcut = getShortListShortcuts().find(function (sc) {
        return sc.id === DateRangeId.last30Days;
      });
      this.actions.updateUsageDetailsDateFilter({
        startDate: this.selectedShortcut.start,
        endDate: this.selectedShortcut.end
      });
    }
  }, {
    key: "setSearchEntitlementsDatePickerToDefaults",
    value: function setSearchEntitlementsDatePickerToDefaults() {
      this.searchEntitlementsDatePicker.shortcut = getShortListShortcuts().find(function (sc) {
        return sc.id === DateRangeId.last30Days;
      });
      this.searchEntitlementsDatePicker.startDate = this.searchEntitlementsDatePicker.shortcut.start;
      this.searchEntitlementsDatePicker.endDate = this.searchEntitlementsDatePicker.shortcut.end;
      this.actions.updateUsageDetailsSearchEntitlementsDatePicker(this.searchEntitlementsDatePicker);
    }
  }, {
    key: "getCallCategoryNamesFromIds",
    value: function getCallCategoryNamesFromIds() {
      var _this4 = this;
      if ((this.state.callCategories || []).length && Object.values(this.state.callCategoryCodeTableValues || {}).length) {
        return this.state.callCategories.map(function (callCategoryId) {
          return _this4.state.callCategoryCodeTableValues[callCategoryId].Name;
        });
      }
      return [];
    }
  }, {
    key: "_buildRetreiveAccountUsageDetailsRequest",
    value: function _buildRetreiveAccountUsageDetailsRequest() {
      return {
        customerId: this.state.currentCustomerId,
        request: {
          CallCategories: this.getCallCategoryNamesFromIds(),
          EndDate: this.state.endDate,
          EntitlementName: this.state.entitlementName,
          NetworkEventSubTypeCodes: this.state.selectedNetworkEventSubTypeFilters.map(function (eventType) {
            return eventType.value;
          }),
          NetworkEventTypeCodes: this.state.selectedNetworkEventTypeFiltersFormat,
          PageNumber: this.state.paginationData.pageNumber,
          PageSize: this.state.paginationData.pageSize,
          ServiceIdentifier: {
            ServiceIdentifierName: this.state.routeParams.serviceIdentifierName,
            Value: this.state.routeParams.serviceIdentifierValue
          },
          EntitlementIdentifier: this.state.isSharedEntitlementUsage ? {
            EntitlementId: this.state.routeParams.entitlementId,
            BalanceIterationId: this.state.routeParams.balanceIterationId
          } : this.state.selectedEntitlement.EntitlementIdentifier,
          SortByField: this.state.sortParams.sortBy,
          SortDirection: this.state.sortParams.sortDirection,
          StartDate: this.state.startDate
        }
      };
    }
  }, {
    key: "navigateToUsageCapsPage",
    value: function navigateToUsageCapsPage() {
      this.actions.stateGo(USAGE_CAPS_URL, {
        serviceId: this.state.routeParams.serviceIdentifierValue
      });
    }
  }, {
    key: "determineUsageCapsButtonVisibility",
    value: function determineUsageCapsButtonVisibility() {
      this.isUsageCapsButtonVisible = !this.state.isSharedEntitlementUsage && !this.state.usageDetails.IsBulkWithServiceType;
    }
  }, {
    key: "onGridRegisterApi",
    value: function onGridRegisterApi(event) {
      var _this5 = this;
      this.gridApi = event.grid.api;
      this.gridApi.core.on.sortChanged(this.$scope, function (grid, sortColumns) {
        _this5.actions.updateUsageDetailsSort({
          sortBy: USAGE_SORT_FIELD[sortColumns[0].field],
          sortDirection: sortColumns[0].sort.direction === _this5.uiGridConstants.ASC ? USAGE_SORT_DIRECTION.ASCENDING : USAGE_SORT_DIRECTION.DESCENDING
        });
        _this5._resetPagination();
        _this5._retrieveConvergentBillerAccountUsageDetails();
      });
    }
  }, {
    key: "_resetPagination",
    value: function _resetPagination() {
      this.actions.updateUsageDetailsPaginationData({
        pageNumber: 1,
        pageSize: this.state.paginationData.pageSize
      });
    }
  }, {
    key: "onPageSelected",
    value: function onPageSelected(page) {
      this.actions.updateUsageDetailsPaginationData({
        pageNumber: page,
        pageSize: this.state.paginationData.pageSize
      });
      this._retrieveConvergentBillerAccountUsageDetails();
    }
  }, {
    key: "onPageSizeOptionSelected",
    value: function onPageSizeOptionSelected(pageSize) {
      this.actions.updateUsageDetailsPaginationData({
        pageNumber: this.state.paginationData.pageNumber,
        pageSize: pageSize
      });
      this._retrieveConvergentBillerAccountUsageDetails();
    }
  }, {
    key: "selectEntitlement",
    value: function selectEntitlement(entitlementIndex, entitlementId, balanceIterationId) {
      if (entitlementIndex === this.state.selectedEntitlementDetails.entitlementIndex) {
        return;
      }
      if (!entitlementId) {
        this.showAll = true;
      } else {
        this.showAll = false;
      }
      this.actions.stateGo(SERVICE_USAGE_DETAILS_STATE_NAME, Object.assign({}, this.state.routeParams, {
        entitlementId: entitlementId,
        entitlementIndex: entitlementIndex,
        balanceIterationId: balanceIterationId
      }), {
        location: 'replace',
        notify: false
      });
      this.actions.updateUsageDetailsSelectedEntitlementDetails({
        entitlementId: entitlementId,
        entitlementIndex: entitlementIndex,
        balanceIterationId: balanceIterationId
      });
      this._resetPagination();
      this.entitlementColumn.visible = this.isEntitlementColumnVisible();
      this.gridApi.core.refresh();
      this._retrieveConvergentBillerAccountUsageDetails();
    }
  }, {
    key: "isEntitlementColumnVisible",
    value: function isEntitlementColumnVisible() {
      return !!(this.state.selectedEntitlement && this.state.selectedEntitlement.EntitlementIdentifier && this.state.selectedEntitlement.EntitlementIdentifier.GroupCode);
    }
  }, {
    key: "isEntitlementActive",
    value: function isEntitlementActive(entitlement) {
      var _entitlement$Entitlem, _this$state$selectedE, _entitlement$Entitlem2, _this$state$selectedE2, _this$state$selectedE3, _entitlement$Entitlem3, _this$state$selectedE4;
      return entitlement !== null && entitlement !== void 0 && (_entitlement$Entitlem = entitlement.EntitlementIdentifier) !== null && _entitlement$Entitlem !== void 0 && _entitlement$Entitlem.EntitlementId ? +entitlement.EntitlementIdentifier.EntitlementId === +((_this$state$selectedE = this.state.selectedEntitlementDetails) === null || _this$state$selectedE === void 0 ? void 0 : _this$state$selectedE.entitlementId) && (entitlement === null || entitlement === void 0 ? void 0 : (_entitlement$Entitlem2 = entitlement.EntitlementIdentifier) === null || _entitlement$Entitlem2 === void 0 ? void 0 : _entitlement$Entitlem2.BalanceIterationId) === ((_this$state$selectedE2 = this.state.selectedEntitlementDetails) === null || _this$state$selectedE2 === void 0 ? void 0 : _this$state$selectedE2.balanceIterationId) || entitlement.index === ((_this$state$selectedE3 = this.state.selectedEntitlementDetails) === null || _this$state$selectedE3 === void 0 ? void 0 : _this$state$selectedE3.entitlementIndex) : (entitlement === null || entitlement === void 0 ? void 0 : (_entitlement$Entitlem3 = entitlement.EntitlementIdentifier) === null || _entitlement$Entitlem3 === void 0 ? void 0 : _entitlement$Entitlem3.GroupCode) === +((_this$state$selectedE4 = this.state.selectedEntitlementDetails) === null || _this$state$selectedE4 === void 0 ? void 0 : _this$state$selectedE4.entitlementId) || entitlement.selectAll && this.state.routeParams.entitlementIndex && !this.state.routeParams.entitlementId;
    }
  }, {
    key: "openAdditionalUsageDetailsPopup",
    value: function openAdditionalUsageDetailsPopup(popupData) {
      var _this6 = this;
      this.additionalUsageDetailsPopupData = popupData;
      this.$timeout(function () {
        _this6.additionalUsageDetailsPopupConfig.open();
      });
    }
  }, {
    key: "closeAdditionalUsageDetailsPopup",
    value: function closeAdditionalUsageDetailsPopup() {
      this.additionalUsageDetailsPopupConfig.close();
    }
  }, {
    key: "isOverrideContainerCollapsed",
    value: function isOverrideContainerCollapsed() {
      var allLocationOverrides = (this.state.selectedEntitlement.PricingVectorOverrides || []).reduce(function (acc, override) {
        acc.push.apply(acc, _toConsumableArray(override.OverrideValues || []));
        return acc;
      }, []);
      return allLocationOverrides.length > LOCATION_OVERRIDES_DISPLAY_MAX;
    }
  }, {
    key: "onApiError",
    value: function onApiError(error) {
      this.uiNotificationService.transientError(error.translatedMessage);
    }
  }, {
    key: "displayExpirationDate",
    value: function displayExpirationDate(entitlement) {
      return ![ENTITLEMENT_ACTIVATION_STATUS.AWAITING_ENTITLEMENT_FIRST_USE, ENTITLEMENT_ACTIVATION_STATUS.AWAITING_SERVICE_FIRST_USE, ENTITLEMENT_ACTIVATION_STATUS.AWAITING_PAYMENT_CONFIRMATION, ENTITLEMENT_ACTIVATION_STATUS.AWAITING_ENTITLEMENT_FIRST_USE_WITH_PRICING_PLAN].includes(entitlement.ActivationStatus);
    }
  }, {
    key: "suspensionDate",
    get: function get() {
      return getFilterService()('localShortDate')(this.state.serviceDetails.SuspendedDate);
    }
  }, {
    key: "suspensionTypeByCode",
    get: function get() {
      return getSuspensionTypeByCode(this.state.serviceDetails.SuspendTypeCode);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.actions.clearUsageDetailsRecoverableUIState();
      this.disconnect();
    }
  }]);
}();
export default {
  template: require('./usage.details.html'),
  bindings: {
    fromStateObject: '<?'
  },
  controller: UsageDetailsController
};